import React from 'react'
import { Field } from 'react-final-form'
import cn from 'classnames'
import { Select } from '@turretcss/react'

import { ErrorField } from './ErrorField'
import { fieldError } from '../utils/fieldError'

export const SelectField = ({ name, label, ...rest }) => (
  <Field name={name}>
    {({ input, meta }) => (
      <div className="field">
        <label htmlFor={name} className={cn({ 'label-required': rest.required })}>
          {label}
        </label>
        <Select {...input} {...rest} id={name} name={name} className={cn({ error: fieldError(meta) })} />
        <ErrorField name={name} />
      </div>
    )}
  </Field>
)
